import "/src/style/main.scss"

import AOS from 'aos';
AOS.init({
    offset: 100,
    duration: 600,
    delay: 100,
    once: true,
});

// // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
// let vh = window.innerHeight * 0.01;
// // Then we set the value in the --vh custom property to the root of the document
// document.documentElement.style.setProperty('--vh', `${vh}px`);

// // We listen to the resize event
// window.addEventListener('resize', () => {
//   // We execute the same script as before
//   let vh = window.innerHeight * 0.01;
//   document.documentElement.style.setProperty('--vh', `${vh}px`);
// });

// Other
import "./functions";

// Modules
import SiteHeader from "./modules/site-header";
SiteHeader().init()

import SiteNav from "./modules/site-nav";
SiteNav().init()

import SiteNavMobile from "./modules/site-nav-mobile";
SiteNavMobile().init()

import Slider from "./modules/slider";
Slider().init()

import ProductSlider from "./modules/product-slider";
ProductSlider().init()

import ShopSlider from "./modules/shop-slider";
ShopSlider().init()

import HomeSliderShop from "./modules/home-shop-slider";
HomeSliderShop().init()

import HowWeWork from "./templates/cost-calculator";
HowWeWork().init()

import Accordions from "./modules/accordions";
Accordions().init()

import Team from "./modules/team-slider";
Team().init()


// Templates

// Template parts

// Pages
